export const defaultTheme = 'light' as const;

export type Theme = 'light' | 'dark';

const strapiThemes = ['light', 'dark', 'decodo-light', 'decodo-dark'] as const;
export type StrapiTheme = (typeof strapiThemes)[number];
export type StrapiThemeObj = {
  id: number;
  themeKey: StrapiTheme;
};

export function findElClosestTheme(el?: HTMLElement) {
  if (!el) return;

  const selector = strapiThemes.map((theme) => `.${theme}`).join(',');

  const closest = el.closest(selector);
  if (!closest) return;

  return strapiThemes.find((theme) => closest.classList.contains(theme));
}

export function reduceStrapiTheme(theme: StrapiTheme): Theme {
  return theme.replace('decodo-', '') as Theme;
}
